export default {
    getHeaderFieldsBNO: state => state.headerFields,
    getSearchFieldsBNO: state => state.searchFields,
    getFormActionsBNO: state => state.formActions,
    getActionsBNO: state => state.actions,
    getRowActionsBNO: state => state.rowActions,
    getDataTableOptionsBNO: state => state.dataTableOptions,
    isFormOpenBNO: state => state.formIsOpen,
    isGridOpenBNO: state => state.gridIsOpen
}
